function formatNumber(n) {
  const str = n.toString();
  return str[1] ? str : `0${str}`;
}

export function formatTime(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  const t1 = [year, month, day].map(formatNumber).join("/");
  const t2 = [hour, minute, second].map(formatNumber).join(":");

  return `${t1} ${t2}`;
}

export function urlEncode(param, key, encode) {
  if (param == null) return "";
  var paramStr = "";
  var t = typeof param;
  if (t == "string" || t == "number" || t == "boolean") {
    paramStr +=
      "&" +
      key +
      "=" +
      (encode == null || encode ? encodeURIComponent(param) : param);
  } else {
    for (var i in param) {
      var k =
        key == null
          ? i
          : key + (param instanceof Array ? "[" + i + "]" : "." + i);
      paramStr += urlEncode(param[i], k, encode);
    }
  }
  return paramStr;
}

export function createUrl(obj) {
  var length = obj && obj.length,
    idx = 0,
    url = "";
  for (var key in obj) {
    if (key != "url" && obj[key] !== null) {
      url += key + "=" + encodeURIComponent(obj[key]) + "&";
    }
  }
  return url.substring(0, url.lastIndexOf("&"));
}
export function genSessionId(length) {
  var str = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
  if (!"0"[0]) {
    //fix IE67
    str = str.split("");
  }
  for (var i = 0, id = "", len = str.length; i < length; i++) {
    id += str[Math.floor(Math.random() * len)];
  }
  return id;
}

export function base64_encode(str) {
  // 编码，配合encodeURIComponent使用
  var c1, c2, c3;
  var base64EncodeChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var i = 0,
    len = str.length,
    strin = "";
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff;
    if (i == len) {
      strin += base64EncodeChars.charAt(c1 >> 2);
      strin += base64EncodeChars.charAt((c1 & 0x3) << 4);
      strin += "==";
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i == len) {
      strin += base64EncodeChars.charAt(c1 >> 2);
      strin += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
      strin += base64EncodeChars.charAt((c2 & 0xf) << 2);
      strin += "=";
      break;
    }
    c3 = str.charCodeAt(i++);
    strin += base64EncodeChars.charAt(c1 >> 2);
    strin += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
    strin += base64EncodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
    strin += base64EncodeChars.charAt(c3 & 0x3f);
  }
  return strin;
}

export function testPhone(phone) {
  var reg = /^1\d{10}$/;
  var result = reg.test(phone);
  return result;
}

// export function scrollEnd(cb) {
//   window.addEventListener("scroll", _scrollEvent(cb));
// }
function getScrollTop() {
  var scrollTop = 0,
    bodyScrollTop = 0,
    documentScrollTop = 0;
  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop;
  }
  scrollTop =
    bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
  return scrollTop;
}
function getScrollHeight() {
  var scrollHeight = 0,
    bodyScrollHeight = 0,
    documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight =
    bodyScrollHeight - documentScrollHeight > 0
      ? bodyScrollHeight
      : documentScrollHeight;
  return scrollHeight;
}
function getWindowHeight() {
  var windowHeight = 0;
  if (document.compatMode == "CSS1Compat") {
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
}
function _scrollEvent(cb) {
  if (getScrollTop() + getWindowHeight() == getScrollHeight()) {
    cb && cb();
  }
}
// scrollEnd.unBind = function() {
//   window.removeEventListener("scroll", _scrollEvent);
// };

export function getUrlParams(url){
  var params = {};
  var urls = url.split("?");
  var queryString = urls[urls.length-1];
  if(queryString.indexOf("=")>-1){
    var arr = queryString.split("&");
    arr.forEach((n,i)=>{
      var a = arr[i].split("=");
      params[a[0]] = a[1]; 
    })
  }
return params
}
export function addNum (num1, num2) {
  var sq1,sq2,m;
  try {
    sq1 = num1.toString().split(".")[1].length;
  }
  catch (e) {
    sq1 = 0;
  }
  try{
    sq2 = num2.toString().split(".")[1].length;
  }
  catch (e) {
    sq2 = 0;
  }
  m = Math.pow(10,Math.max(sq1, sq2));
  return (num1 * m + num2 * m) / m;
}
export function hideCode(str,beginStr,endStr){
  var len = str.length;
  if(len<beginStr||len<endStr){
    return str;
  }
  var leftStr = str.substring(0,beginStr);
  var rightStr = str.substring(endStr,len);
  var str = ''
  var i = 0;
  try {
      for (i = 0; i < endStr-beginStr;i++) {
          str = str + '*';
      }
  } catch (error) {
      
  }
  str = leftStr + str + rightStr;
  return str;
}


// WEBPACK FOOTER //
// ./src/utils/index.js